import DataTable from "react-data-table-component"
import Footer from "../../components/molecules/footer/Footer"
import Header from "../../components/molecules/header/Header"
import ConstantesTabla from "../../utils/ConstantesTabla"
import { useState } from "react"
import { Iconos } from "../../utils/Iconos"
import { useNavigate } from "react-router-dom"

const ListadoActos = () => {
    const navigate = useNavigate();

    const [actos] = useState([
        {
            modelo: "S1",
            nombre: "Variación de datos personales",
            descripcion: "",
            ruta: "/variacionDatosPersonales",
            enlaceInstrucciones: "https://portalempleado.juntaex.es/w/s1-variacion-de-datos-personales-instrucciones",
            enlacePreguntasFrecuentes: "https://portalempleado.juntaex.es/w/tramite-s1-variacion-de-datos-personales-preguntas-frecuentes"
        },
        {
            modelo: "Z9",
            nombre: "Reconocimiento de nivel de carrera horizontal",
            descripcion: "",
            ruta: "/reconNivelCarrera",
            enlaceInstrucciones: "https://portalempleado.juntaex.es/w/tramite-z9-solicitud-carrera-instrucciones",
            enlacePreguntasFrecuentes: "https://portalempleado.juntaex.es/w/tramite-z9-solicitud-carrera-preguntas-frecuentes"
        }
        // ,
        // {
        //     modelo: "18",
        //     nombre: "Reconocimiento de servicios previos en Otras Administraciones",
        //     descripcion: "",
        //     ruta: "/reconServiciosPrevios"
        // }
    ]);
    const columnas = [
        {
            name: <h2 className="tituloModal-mini">Trámites</h2>,
            selector: (row) => (<>
                <div className="fw-bold fs-5">Modelo {row.modelo}</div>
                <div className="">{row.nombre}</div>
            </>),
            grow: 1,
            wrap: true,
        },
        {
            name: "",
            selector: (row) => (<>
                <div className="d-flex">
                    <div className="mx-1 cursorPointer"
                        onClick={() => navigate(`${row.ruta}`)}
                        tabIndex={0}
                        title="Ver Trámite"
                        aria-label="Ver Trámite"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                navigate(`${row.ruta}`)
                            }
                        }}>{Iconos.iconoCheck}</div>
                    <div className="mx-1 cursorPointer" tabIndex={0}
                        title="Instrucciones del trámite"
                        aria-label="Instrucciones del trámite"
                        onClick={() => {
                            window.open(row.enlaceInstrucciones)
                        }}
                        onKeyDown={() => {
                            window.open(row.enlaceInstrucciones)
                        }}
                    >{Iconos.iconoInfo}</div>
                    <div className="mx-1 cursorPointer" tabIndex={0}
                        title="Preguntas frecuentes"
                        aria-label="Preguntas frecuentes"
                        onClick={() => {
                            window.open(row.enlacePreguntasFrecuentes)
                        }}
                        onKeyDown={() => {
                            window.open(row.enlacePreguntasFrecuentes)
                        }}
                    >{Iconos.iconoAyuda}</div>
                </div>
            </>),
            grow: 1,
            wrap: true,
            right: true
        }
    ]

    return (<>
        <Header />
        <div className="container listadoactos" role="main" data-landmark-index="4">
            <div className="tablaactos">
                <DataTable
                    className="table-responsive"
                    columns={
                        columnas
                    }
                    data={actos}
                    pagination
                    paginationComponentOptions={
                        ConstantesTabla.paginacionOpt
                    }
                    noDataComponent={
                        <span descripcion="table-no-data-registro" />
                    }
                    customStyles={ConstantesTabla.customStyles}
                />
            </div>
            <div className="gridBotones mb-2">
                <button
                    id="volver"
                    className="btnRed rounded btnCancelarDocumentacion"
                    type="button"
                    onClick={() => {
                        localStorage.removeItem("datosIrpfSelect")
                        navigate("/home")

                    }}
                >
                    <i className="fa-solid fa-rotate-left"></i> Volver
                </button>
            </div>
        </div>
        <Footer />
    </>)
}
export default ListadoActos